/**
 * Brand Colors Configuration
 * Centralized color variables used throughout the project
 */

export const brandColors = {
  // Primary brand color - used for hover states and primary actions
  primary: '#A91FC2',

  // Secondary brand color - used for selected/reset states
  secondary: '#E6D0EA',

  // Additional utility colors
  border: '#ced4da',
  borderFocus: '#80bdff',
  focusShadow: 'rgba(0, 123, 255, 0.25)',
}

export default brandColors
